document.addEventListener('DOMContentLoaded', function () {
    const track = document.getElementById('testimonialTrack');
    const cards = track.querySelectorAll('.custom-testimonials-card');
    const prevButton = document.querySelector('.custom-testimonials-prev');
    const nextButton = document.querySelector('.custom-testimonials-next');

    let currentIndex = 2;
    let startPos = 0;
    let currentTranslate = 0;
    let prevTranslate = 0;
    let isDragging = false;
    let animationID = 0;
    let autoSlideEnabled = false;

    cards.forEach(card => {
        const images = card.querySelectorAll('img');
        const links = card.querySelectorAll('a');
        images.forEach(img => img.addEventListener('dragstart', e => e.preventDefault()));
        links.forEach(link => link.addEventListener('click', e => { if (isDragging) e.preventDefault(); }));
    });

    // Touch events with passive set to false for iOS Safari
    track.addEventListener('touchstart', dragStart, { passive: false });
    track.addEventListener('touchend', dragEnd);
    track.addEventListener('touchmove', drag, { passive: false });

    // Mouse events
    track.addEventListener('mousedown', dragStart);
    track.addEventListener('mouseup', dragEnd);
    track.addEventListener('mouseleave', dragEnd);
    track.addEventListener('mousemove', drag);

    function dragStart(event) {
        startPos = event.type === 'touchstart' ? event.touches[0].clientX : event.clientX;
        isDragging = true;
        animationID = requestAnimationFrame(animation);
        track.style.transition = 'none';
    }

    function drag(event) {
        if (isDragging) {
            const currentPosition = event.type === 'touchmove' ? event.touches[0].clientX : event.clientX;
            currentTranslate = prevTranslate + currentPosition - startPos;
        }
    }

    function dragEnd() {
        isDragging = false;
        cancelAnimationFrame(animationID);

        const movedBy = currentTranslate - prevTranslate;
        if (movedBy < -100 && currentIndex < cards.length - 1) currentIndex += 1;
        if (movedBy > 100 && currentIndex > 0) currentIndex -= 1;

        setPositionByIndex();
        track.style.transition = 'transform 0.3s ease';
    }

    function animation() {
        if (isDragging) {
            setSliderPosition();
            requestAnimationFrame(animation);
        }
    }

    function setSliderPosition() {
        track.style.transform = `translateX(${currentTranslate}px)`;
    }

    function setPositionByIndex() {
        const cardWidth = cards[0].offsetWidth;
        const marginRight = parseInt(window.getComputedStyle(cards[0]).marginRight);
        currentTranslate = (cardWidth + marginRight) * currentIndex * -1;
        prevTranslate = currentTranslate;
        setSliderPosition();
    }

    function moveToNextSlide() {
        currentIndex = currentIndex < cards.length - 1 ? currentIndex + 1 : 0;
        setPositionByIndex();
    }

    function moveToPrevSlide() {
        currentIndex = currentIndex > 0 ? currentIndex - 1 : cards.length - 1;
        setPositionByIndex();
    }

    nextButton.addEventListener('click', moveToNextSlide);
    prevButton.addEventListener('click', moveToPrevSlide);

    let autoSlideInterval;
    function startAutoSlide() {
        if (autoSlideEnabled) {
            autoSlideInterval = setInterval(moveToNextSlide, 5000);
        }
    }

    startAutoSlide();
    track.addEventListener('mouseenter', () => clearInterval(autoSlideInterval));
    track.addEventListener('mouseleave', () => {
        clearInterval(autoSlideInterval);
        startAutoSlide();
    });

    setPositionByIndex();
});
